/**
 * Where the backend delivered the verification code: 'email' | 'sms'.
 */

/**
 * POST /customer/login answers with either a completed login (has `token`) or a
 * 2FA challenge (has `challenge_token`) — the shape is the discriminator.
 */
export function isTwoFactorChallenge (payload) {
  return !!payload?.challenge_token
}

/**
 * How far the server clock is ahead of the device clock, in ms — derived from
 * the `server_time` the backend stamps on 2FA responses. `null` when the
 * backend didn't send it, i.e. the device clock can't be trusted for expiry.
 */
export function clockOffsetFrom (serverTime) {
  const serverMs = serverTime ? Date.parse(serverTime) : NaN

  return Number.isNaN(serverMs) ? null : serverMs - Date.now()
}

export function toTwoFactorChallenge (payload) {
  return {
    challenge_token: payload.challenge_token,
    clock_offset_ms: clockOffsetFrom(payload.server_time),
    expires_at: payload.expires_at,
    resend_available_at: payload.resend_available_at,
    /** Always present, regardless of the delivery channel. */
    email_masked: payload.email_masked,
    /** Set only when channel === 'sms'. */
    phone_masked: payload.phone_masked ?? null,
    channel: payload.channel === 'sms' ? 'sms' : 'email',
  }
}
